module.exports = __webpack_public_path__ + "media/images/v3/icon4-8cabe9d9c3a7dac7df80775ba92609d1.png";